function hideLoading() {
  $('body').loading('stop');
}

$(document).ready(function() {
  // Handle AJAX errors to hide loading
  $(document).ajaxError(function(event, jqxhr, settings) {
    if (settings.url && settings.url.includes('/imports/import_korabo_ntt')) {
      if (jqxhr.status === 400) {
        hideLoading();
        const errorData = jqxhr.responseJSON || {};
        const errorMsg = errorData.error || 'リクエストが無効です。';
        alert(errorMsg);
      }
    }
  });

  // Show loading when form is submitted
  $('.korabo-import-form').on('submit', function() {
    setTimeout(function() {
      $('body').loading({
        message: 'CSVファイルを処理中...',
        zIndex: 9999
      });
    }, 300);
  });

  $('.korabo-ntt-import-form').on('submit', function(e) {
    const $form = $(this);
    const files = $form.find('.korabo-ntt-files').prop('files');

    if (!files.length) {
      alert('ファイルを選択してください。');
      return false;
    }

    const invalidFiles = Array.from(files).filter(file => {
      const ext = file.name.split('.').pop().toLowerCase();
      return ext !== 'csv' && ext !== 'zip';
    });

    if (invalidFiles.length > 0) {
      alert(`CSVまたはZIP以外のファイルは取り込めません。\nファイル: ${invalidFiles.map(f => f.name).join(', ')}`);
      return false;
    }

    setTimeout(function() {
      $('body').loading({
        message: 'NTTデータをチェック中...',
        zIndex: 9999
      });
    }, 300);
  });

  $(document).on('submit', '.korabo-ntt-create-bills-form', function(event) {
    const $billingDate = $(this).find('.korabo-billing-date');
    if ($billingDate.length && !isValidBillingDate($billingDate.val())) {
      event.preventDefault();
      $billingDate.addClass('is-invalid').focus();
      return;
    }

    $billingDate.removeClass('is-invalid');
    setTimeout(function() {
      $('body').loading({
        message: '請求データを作成中...',
        zIndex: 9999
      });
    }, 300);
  });
});

function isValidBillingDate(value) {
  const match = String(value || '').match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
  if (!match) return false;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}

$(document).on('input change', '.korabo-billing-date', function() {
  $(this).toggleClass('is-invalid', !isValidBillingDate($(this).val()));
});
